import { RightCircleOutlined } from "@ant-design/icons";
import { FC } from "react"
import { SocialShare } from "../../social/SocialShare";
import { Link } from "../../../components";


interface FeaturedCardProps {
    url: string;
    mediaUrl: string;
    title: string;
    description: string;
}

export const FeaturedCard: FC<FeaturedCardProps> = ({
    url,
    mediaUrl,
    title,
    description,
}) => {
    return (
        <div className="group w-full aspect-video sm:aspect-[12/5] relative bg-sky-950/95">
            <Link to={url} className="transition-all  h-full w-full" title={title}>
                <img src={mediaUrl} alt={title} className="object-cover object-left-top w-full h-full sm:aspect-[12/5] hover:scale-105 hover:translate-y-1 transition-all duration-1000" />
                <div className="transition-all duration-300 hidden sm:block absolute text-white bottom-0 right-0 top-0 sm:left-auto bg-gradient-to-r from-transparent via-20% via-sky-900/30 to-sky-900/75 group-hover:bg-slate-950/75 px-8 pl-16 py-6 max-w-1/3 w-[400px] md:w-[500px] box-border z-10">
                    <h2 className="font-bold texl-lg md:text-xl">{title}</h2>
                    <p className="md:text-lg py-4">{description}</p>
                </div>
                <div className="sm:hidden w-full pt-3 px-3 pb-5 text-white absolute bottom-0 left-0 right-0 bg-gradient-to-b from-transparent via-sky-950/75 to-sky-950">
                    <div className="flex flex-col w-full justify-center text-center">
                        <h2 className="font-bold text-white">{title}</h2>
                        {/*<p>{description}</p>*/}
                    </div>
                </div>
            </Link>
            <div className="hidden sm:flex absolute bottom-6 right-8 z-10 flex-row items-end justify-end pt-8 gap-12">
                <span className="transition-all opacity-0 cursor-pointer group-hover:opacity-100 uppercase font-bold italic text-white px-3 py-1 bg-sky-950 border-2 border-white rounded-full hover:text-sky-950 hover:bg-white active:scale-95" title={title}>Читать <RightCircleOutlined /></span>
                <div className="flex flex-col md:flex-row items-center gap-2 text-white">
                    Рассказать друзьям:
                    <SocialShare
                        title={title}
                        description={description}
                        imageUrl={mediaUrl}
                        url={url}
                        keys={['vk', 'telegram', 'whatsapp']}
                        iconClassName="!w-9 !h-9"
                        iconColor="light"
                    />
                </div>
            </div>
        </div>
    )
}
